module.exports = __webpack_public_path__ + "img/yuebao.22636c78.png";